//#region
import axios from 'axios';
import { url, endPoint } from '../urls';
//#endregion

export const getReportsList = (params) => {
    let _url = url.backendHost + endPoint.reports.getReportsList;
    return axios.get(_url, { params });
}

export const getMeasuresList = (params) => {
    let _url = url.backendHost + endPoint.reports.getReportsList;
    return axios.get(_url, { params });
}
export const deleteReport = (params) => {
    let _url = url.backendHost + endPoint.reports.deleteReport;
    return axios.put(_url, params);
}

export const changeReportOwner = (params) => {
    let _url = url.backendHost + endPoint.reports.changeReportOwner;
    return axios.post(_url, params);
}

export const getReportById = (params) => {
    let _url = url.backendHost + endPoint.reports.getReportById;
    return axios.get(_url, { params });
}

export const updateReportById = (params) => {
    let _url = url.backendHost + endPoint.reports.updateReportById;
    return axios.post(_url, params);
}

export const addReport = (params) => {
    let _url = url.backendHost + endPoint.reports.addReport;
    return axios.post(_url, params);
}

export const getReportsWithFolders = (params) => {
    let _url = url.backendHost + endPoint.reports.getReportsWithFolders;
    return axios.get(_url, { params });
}
export const validateUserReport = (params) => {
    let _url = url.backendHost + endPoint.reports.validateUserReport;
    return axios.get(_url, { params });
}

export const removeReportFromFolder = (params) => {
    let _url = url.backendHost + endPoint.reports.removeReportFromFolder;
    return axios.post(_url, params);
}

export const getAllReports = (params) => {
    let _url = url.backendHost + endPoint.reports.getAllReports;
    return axios.get(_url, { params });
}

export const reportExport = (params) => {
    let _url = url.backendHost + endPoint.reports.exportReport;
    return axios.post(_url, params);
}

export const reportImport = (params) => {
    let _url = url.backendHost + endPoint.reports.importReport;
    return axios.post(_url, params);
}

export const getDownloadReportList = (params) => {
    let _url = url.backendHost + endPoint.reports.downloadReportList;
    return axios.get(_url, { params });
}